<template>
  <v-col class="text-center">
    <v-img
      :class="align === 'left' ? 'ml-0 mr-auto' : 'ma-auto'"
      :max-width="max_width"
      :width="width"
      :src="imageSrc + source"
      contains
    >
    </v-img>
    <b>{{caption}}</b>
  </v-col>
</template>

<script>
export default {
  name: "ConfigImage",
  props: {
    source: String,
    caption: String,
    max_width: String,
    width: String,
    webp: Boolean,
    align: String
  },
  computed: {
    imageSrc() {
      if (!this.webp){
        return this.$imageSrc;
      }
      else {
        return this.$imageSrc;
      }
    }
  }
};
</script>
